import DateService from '~/services/Date';
import { REGULARITY } from '~/types/product';

export const checkIsSubUnlimited = (
  isStripe: boolean,
  isTrial: boolean,
  regularity: REGULARITY,
): boolean => {
  return !isStripe && regularity === REGULARITY.YEAR && !isTrial;
};

export const getTrialDistancePassed = (
  startedAt: string,
  trialPeriod: number,
): number => {
  const startDate = DateService.toDate(new Date(startedAt));
  const todayDate = DateService.toDate(Date.now());

  const difference = DateService.differenceInDays(todayDate, startDate);

  return difference < trialPeriod ? difference : trialPeriod;
};

export const getTrialDistanceLeft = (
  startedAt: string,
  trialPeriod: number, // in days
): number => {
  const startDate = new Date(startedAt).getTime();
  const endDate = startDate + trialPeriod * 24 * 60 * 60 * 1000;
  const now = Date.now();

  const msLeft = endDate - now;

  return msLeft > 0 ? msLeft : 0;
};
